import React, { useState } from "react";
import { Label } from "reactstrap";
import { Calendar } from "react-feather";
import Picker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.scss";

const DatePicker = (props) => {
  const {
    className = "",
    inputClassName = "",
    label,
    icon: Icon,
    selected,
    selectsRange,
    onChange,
    startDate,
    endDate,
    placeholder,
    isKeyDown = true,
    maxDate,
    minDate,
    width = "100%",
    dateFormat = "dd/MM/yyyy",
    isFilter,
    err,
    ...rest
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const errorMessage = err

  return (
    <div
      className={`${className} react-date-picker d-flex flex-column select-div`}
      onMouseLeave={() => setIsOpen(false)}
    >
      {label ? <Label>{label}</Label> : null}
      <div
        className="d-flex align-items-center flatpicker-main-div"
        style={{ width: width }}
        onClick={() => {
          if (!props?.disabled) setIsOpen(true);
        }}
      >
        {Icon ? Icon : <Calendar size={20} />}
        <Picker
          className="datepicker"
          selected={selected}
          onChange={(e) => {
            onChange?.(e);
          }}
          {...(isKeyDown && {
            onKeyDown: (e) => {
              if (e.key === "Backspace" || e.key === "Delete") {
                onChange?.(selectsRange ? [null, null] : null);
              }
            }
          })}
          selectsRange={selectsRange}
          startDate={startDate}
          endDate={endDate}
          placeholderText={placeholder}
          maxDate={maxDate}
          minDate={minDate}
          autoComplete="off"
          dateFormat={dateFormat}
          open={isOpen}
          {...rest}
        />
      </div>
      {errorMessage ? (
        <span style={{ color: "red", fontSize: 12 }}>{errorMessage}</span>
      ) : null}
    </div>
  );
};

export default DatePicker;
